module.exports = __webpack_public_path__ + "static/img/51talk_small.7f3fea2.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/51talk_small.gif
// module id = T+qC
// module chunks = 1